

import { RootState } from "@service/store/types/RootState";
import { DateTime } from "luxon";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})

export default class CardsSectionBase extends Vue {

    @Prop({ default: 0 }) thresholdCount: number;
    @Prop({ default: false }) stretch: boolean;
    @Prop({ default: "" }) cardClass: string;

    selectedDate: DateTime | null = null;

    showAll = false;

    readonly main = "cards-section";
    readonly header = "cards-section__header";
    readonly segments = "cards-section__segments";
    readonly date = "cards-section__date";
    readonly filter = "cards-section__filter";
    readonly grid = "cards-section__grid";
    readonly left = "cards-section__left";
    readonly title_class = "cards-section__title";

    getSizeClass(items: any[]) {
        if(this.stretch) {

            switch (items.length) {
                case 1:
                    return 'gr-c-1';

                case 2:
                    return 'gr-c-2';

                case 3:
                    return 'gr-c-3';

                case 4:
                    return 'gr-c-4';
            }

            return 'gr-c-4';

        }
        else {
            return "gr-c-4";
        }
    }

    get selectedTimeZone() {
        return (this.$store.state as RootState).selectedTimeZoneOffset?.toString() || "";
    }
}

